import { toUpperCase } from "remeda";
import { type Task, TaskLabel } from "shared-core/types/task";

export function formatTaskLabels(tasks: Task[]): Task[] {
  tasks.forEach((a) => {
    a.labels.push(
      TaskLabel[
        `${toUpperCase(a.priority.toString())}_PRIORITY` as keyof typeof TaskLabel
      ],
    );
    a.labels.push(
      TaskLabel[
        `${toUpperCase(a.riskLevel.toString())}_RISK_LEVEL` as keyof typeof TaskLabel
      ],
    );
  });

  return tasks;
}
